<template>
  <div>
    <div>
      <RouterLink :to="useDetailsRoute(assignment)" class="pointer text-light-green">
        {{ assignment.reference }}
      </RouterLink>
    </div>

    <div v-if="assignment.archived">
      <b-badge variant="danger"> Archived </b-badge>
    </div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { BBadge } from 'bootstrap-vue-next'
import { defineComponent, type PropType } from 'vue'
import { useDetailsRoute } from '@/composables/Assignment/useDetailsRoute'

export default defineComponent({
  name: 'ReferenceCell',
  components: { BBadge },
  props: {
    assignment: {
      type: Object as PropType<Assignment>,
      required: true,
    },
  },
  setup() {
    return {
      useDetailsRoute,
    }
  },
})
</script>
